/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './listHosts.defs'
export { main as default } from './listHosts.defs'
